import { render } from "./UpdateOrder.vue?vue&type=template&id=40be4d43"
import script from "./UpdateOrder.vue?vue&type=script&lang=js"
export * from "./UpdateOrder.vue?vue&type=script&lang=js"
script.render = render

export default script